import * as z from "zod";

import {
  apiScopesSchema,
  apiTokenNameSchema,
  StoreApiTokenSummarySchema,
} from "../shared/api-token";
import { storeIdSchema } from "../shared/store";

/** The secret is returned once, here, and never again. */
export const createStoreApiToken = {
  name: "createStoreApiToken" as const,
  input: z.object({
    storeId: storeIdSchema,
    name: apiTokenNameSchema,
    // Omitted means every scope the store granted.
    scopes: apiScopesSchema.min(1).optional(),
  }),
  output: z.object({
    token: StoreApiTokenSummarySchema,
    secret: z.string().min(1),
  }),
};
